module.exports = __webpack_public_path__ + "img/PjHIS.2e12753c.png";